import React, { useContext, useEffect, useState } from "react";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserTypesEnum from "../../../models/UserTypesEnum";
import OwButton from "../OwButton/OwButton";
import OwTranslate from "../OwTranslate/OwTranslate";
import * as _ from "lodash-es";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";

type Props = {
    disabled: boolean;
    active: boolean;
    viewFn: (data?: any) => void;
    voidFn: (data?: any) => void;
    deleteFn: (data?: any) => void;
    data?: any;
    fieldsetClassName?: string;
};

export const QBOInvoiceActions: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);

    const viewInvoice = () => {
        props.viewFn(props.data);
    };

    const voidInvoice = () => {
        props.voidFn(props.data);
    };

    const deleteInvoice = () => {
        props.deleteFn(props.data);
    };

    return (
        <div className={"QBOInvoiceActions"}>
            <div className={"d-inline-block mb-1"}>
                <OwButton
                    disabled={props.disabled}
                    active={props.active}
                    leftIconClass="fas fa-file-alt"
                    className="btn-primary mb-2 mb-md-0"
                    title="view"
                    hoverTitle={"View Invoice"}
                    fn={viewInvoice}
                />

                {userModel.isSupplierUser && userModel.userType!.id === UserTypesEnum.ADMIN ? (
                    <OwButton
                        disabled={props.disabled}
                        active={props.active}
                        leftIconClass={"fad fa-do-not-enter"}
                        className={"btn-danger mb-2 mb-md-0 ms-2"}
                        title={"void"}
                        hoverTitle={"Void Invoice"}
                        fn={voidInvoice}
                    />
                ) : null}

                {userModel.isSupplierUser && userModel.userType!.id === UserTypesEnum.ADMIN ? (
                    <OwButton
                        disabled={props.disabled}
                        active={props.active}
                        leftIconClass={"fad fa-trash"}
                        className={"btn-danger mb-2 mb-md-0 ms-2"}
                        title={"delete"}
                        hoverTitle={"Delete Invoice"}
                        fn={deleteInvoice}
                    />
                ) : null}
            </div>
        </div>
    );
};
